<template>
  <div class="home-menu-section">
    <div @click="openHelpDialog" class="help-icon-link">
      <img src="@/assets/img/ic_help.png" alt="Bantuan">
    </div>

    <div class="modal-overlay" v-if="isHelpDialogOpen">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ℹ️ Bantuan & Informasi</h5>
          </div>
          <div class="modal-body">
            <p>Cashless: layanan ini digunakan apabila kartu peserta atau e-card dapat diproses oleh rumah sakit. Peserta
              cukup menunjukkan kartu, dan biaya sesuai manfaat akan diproses tanpa pembayaran di awal.</p>
            <p>Cashless Standby: layanan ini digunakan apabila kartu peserta atau e-card tidak dapat diproses di rumah sakit.
              Peserta tetap dapat menerima perawatan tanpa membayar di awal dengan melakukan verifikasi manual
              melalui WhatsApp Salvus di 0851-7988-6909.</p>
          </div>
          <div class="modal-footer">
            <button @click="closeHelpDialog" class="btn btn-primary">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mt-5">
        <div class="home-menu mb-3">
          <router-link to="/rekanan-list/?type=RS" class="home-menu-list">
            <div class="home-menu-icon">
              <img src="@/assets/img/icon/rumah-sakit.png" alt="rumah-sakit">
            </div>
            <div class="home-menu-text text-color-grey mt-3">
              Rumah Sakit
            </div>
          </router-link>
          <router-link to="/rekanan-list/?type=KLINIK" class="home-menu-list">
            <div class="home-menu-icon">
              <img src="@/assets/img/icon/klinik.png" alt="klinik">
            </div>
            <div class="home-menu-text text-color-grey mt-3">
              Klinik
            </div>
          </router-link>
        </div>
        <div class="home-menu mb-3">
          <router-link to="/rekanan-list/?type=LAB" class="home-menu-list">
            <div class="home-menu-icon">
              <img src="@/assets/img/icon/laboratorium.png" alt="laboratorium">
            </div>
            <div class="home-menu-text text-color-grey mt-3">
              Laboratorium
            </div>
          </router-link>
          <router-link to="/rekanan-list/?type=OPTIK" class="home-menu-list">
            <div class="home-menu-icon">
              <img src="@/assets/img/icon/optik.png" alt="optik">
            </div>
            <div class="home-menu-text text-color-grey mt-3">
              Optik
            </div>
          </router-link>
        </div>
        <div class="col-6 home-menu d-block">
          <router-link to="/rekanan-list/?type=APOTEK" class="home-menu-list">
            <div class="home-menu-icon">
              <img src="@/assets/img/icon/apotek.png" alt="apotek">
            </div>
            <div class="home-menu-text text-color-grey mt-3">
              Apotik
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isHelpDialogOpen: false
    }
  },
  props: {

  },
  methods: {
    openHelpDialog() {
      this.isHelpDialogOpen = true;
    },
    closeHelpDialog() {
      this.isHelpDialogOpen = false;
    }
  }
}
</script>

<style>
.home-menu-section {
  position: relative;
}

.help-icon-link {
  position: absolute;
  top: 40px;
  left: 20px;
  z-index: 10;
  cursor: pointer;
}

.help-icon-link img {
  width: 52px;
  height: 52px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-dialog {
  max-width: 400px;
  width: 90%;
  margin: 1.75rem;
}

.modal-content {
  background-color: #fff;
  border-radius: 0.3rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  padding: 15px;
}

.modal-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
}

.modal-body p {
  margin-bottom: 10px;
}

.modal-footer {
  padding-top: 10px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border: 1px solid #007bff;
  padding: 8px 15px;
  border-radius: 0.25rem;
  cursor: pointer;
}

</style>